import { useEffect, useRef, useState } from "react";
import Card from "../../../components/Card/Card";
import List from "../../../components/List/List";
import Pagination from "../../../components/Pagination/Pagination";
import SyncIcon from "../../../components/SyncIcon/SyncIcon";
import { useSSEContext } from "../../../contexts/sse";
import { useUserStore } from "../../../contexts/userStore";
import InterlockService from "../../../services/InterlockService";
import BooleanSlider from "../../../components/BooleanSlider/BooleanSlider";
import "./ListInterlocks.css";

const ListInterlocks = (props) => {
  const [interlocks, setInterlocks] = useState([]);
  const [maxPage, setMaxPage] = useState(1);
  const { selectedCondominio, selectedLicenceId } = useUserStore();
  const [currentPage, setCurrentPage] = useState(1);
  const { sseReceived } = useSSEContext();
  const [collumnClicked, setCollumnClicked] = useState({
    collumnTitle: "createdAt",
    orderDirection: "DESC",
  });
  const [isLoading, setIsLoading] = useState(true);
  const [updatingInterlocks, setUpdatingInterlocks] = useState(() => new Set());
  const cancelTokenRef = useRef(null);

  const handleEnabledChange = async (interlock, enabled) => {
    setUpdatingInterlocks((current) => new Set(current).add(interlock.id));

    try {
      const response = await InterlockService.updateInterlock(interlock.id, {
        ...interlock,
        enabled,
      });

      if ([200, 201, 204].includes(response?.status)) {
        setInterlocks((current) =>
          current.map((item) =>
            item.id === interlock.id ? { ...item, enabled } : item
          )
        );
      }
    } finally {
      setUpdatingInterlocks((current) => {
        const next = new Set(current);
        next.delete(interlock.id);
        return next;
      });
    }
  };

  const getInterlocks = async (
    page,
    searchText,
    condominiumId,
    licenceId,
    collumnClicked
  ) => {
    if (condominiumId === 0 || !licenceId) return;
    if (cancelTokenRef.current) {
      cancelTokenRef.current.abort();
    }
    cancelTokenRef.current = new AbortController();
    setIsLoading(true);
    const response = await InterlockService.listInterlocksPaginated(
      page,
      searchText,
      condominiumId,
      licenceId,
      collumnClicked,
      cancelTokenRef.current.signal
    );
    setIsLoading(false);
    setInterlocks(response.data?.items);
    setCurrentPage(page);
    setMaxPage(response.data?.totalPages);
  };

  useEffect(() => {
    getInterlocks(
      currentPage,
      props.filters,
      selectedCondominio,
      selectedLicenceId,
      collumnClicked
    );
  }, [
    props.filters,
    selectedCondominio,
    selectedLicenceId,
    collumnClicked,
    props.refreshKey,
    currentPage
  ]);

  useEffect(() => {
    if (sseReceived?.action === "replyInterlockReceived") {
      getInterlocks(
        currentPage,
        props.filters,
        selectedCondominio,
        selectedLicenceId,
        collumnClicked
      );
    }
  }, [
    sseReceived,
  ]);

  return (
    <>
      <div className="list-container list-visibility">
        <List
          isLoading={isLoading}
          handleCollumnTitleClick={(collumnIndex) =>
            setCollumnClicked(collumnIndex)
          }
          listEntityName="interlocks"
          collumsObjIndex={[
            { collumnLabel: "Nome", index: "name", type: "text" },
            {
              collumnLabel: "Habilitado",
              index: "enabled",
              type: "enabled",
              custom: ({ row }) => (
                <BooleanSlider
                  value={row.enabled}
                  label={`Habilitar ${row.name}`}
                  loading={updatingInterlocks.has(row.id)}
                  onChange={(enabled) => handleEnabledChange(row, enabled)}
                />
              ),
            },
            { collumnLabel: "Status", index: "status", type: "sync-status" },
          ]}
          data={interlocks}
        />
      </div>
      <div className="card-visibility">
        {interlocks &&
          interlocks.map((interlock, index) => (
            <Card
              key={index}
              data={interlock}
              delete={() => InterlockService.deleteInterlock(interlock.id)}
              navigateOnDelete={"../consulta-interlocks"}
              navigateOnEdit={"../cadastro-interlocks"}
              aditionalButton1={
                <SyncIcon
                  isCard={true}
                  syncStatus={interlock.status}
                  data={interlock}
                  listEntityName={"interlocks"}
                />
              }
            >
              <p className="card-content-title">{interlock.name}</p>
              <p className="card-content">
                Descrição: {interlock.description}
              </p>
            </Card>
          ))}
      </div>
      <Pagination
        rowsPerPage={8}
        maxPage={maxPage}
        changePage={(page) =>
          setCurrentPage(page)
        }
      />
    </>
  );
};

export default ListInterlocks;
